

import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LoginForm } from './components/auth/LoginForm';
import { SignupForm } from './components/auth/SignupForm';
import { AuthCallback } from './components/auth/AuthCallback';
import { LandingPage } from './pages/landingPage';
import { DashboardLayout } from './components/Layout/DashboardLayout';
import { PatientsPage } from './pages/PatientsPage';
import { CertificateFormPage } from './pages/CertificateFormPage';
import { DoctorAccessPage } from './pages/DoctorAccessPage';
import { DoctorPaymentsPage } from './pages/DoctorPaymentsPage';
import { CertificateViewPage } from './pages/CertificateViewPage';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import SheetsSyncPage from './features/sheets-sync/components/SheetsSyncPage';
import SheetsSettingsPage from './features/sheets-sync/components/SheetsSettingsPage';
import { AdminDoctorsPage } from './pages/AdminDoctorsPage';

const App: React.FC = () => (
  <BrowserRouter>
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/signup" element={<SignupForm />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/doctor/access" element={<DoctorAccessPage />} />

        {/* Dashboard layout — wraps all app routes */}
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<Navigate to="/patients" replace />} />
          <Route path="/patients" element={<PatientsPage filter="all" />} />
          <Route path="/patients/pending" element={<PatientsPage filter="pending" />} />
          <Route path="/patients/submitted" element={<PatientsPage filter="submitted" />} />
          <Route path="/patients/assigned" element={<PatientsPage filter="assigned" />} />
          <Route path="/patients/refunded" element={<PatientsPage filter="refunded" />} />
          <Route path="/patients/issued" element={<PatientsPage filter="issued" />} />
          <Route path="/patients/rejected" element={<PatientsPage filter="rejected" />} />
          {/* Static paths above must come before the dynamic segment */}
          <Route path="/patients/:docId/pdf" element={<CertificateViewPage />} />
          <Route path="/patients/:docId" element={<CertificateFormPage />} />
          <Route path="/doctors" element={<DoctorPaymentsPage />} />
          {/* Admin-only: Google Sheets sync */}
          <Route element={<ProtectedRoute requiredRole="admin" />}>
            <Route path="/admin/doctors" element={<AdminDoctorsPage />} />
            <Route path="/admin/sheets-sync" element={<SheetsSyncPage />} />
            <Route path="/admin/sheets-settings" element={<SheetsSettingsPage />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  </BrowserRouter>
);

export default App;

